<template>
  <v-card>
    <v-card-title>{{$t('campaigns.automatic.priority.title')}}</v-card-title>
    <v-list class="pfcl1618819138">
      <v-subheader>{{$t('campaigns.automatic.priority.high')}}</v-subheader>
      <transition-group name="list" tag="div">
          <v-list-item  v-for="(c, i) in items" :key="c.id">
            <v-list-item-icon>
              <v-icon :color="getCampaignStateColor(c.state)">{{ mediumIcon(c.medium) }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ c.name }}</v-list-item-title>
                <!-- <v-list-item-subtitle><span :class="`${getCampaignStateColor(c.state)}--text`">{{ c.state }}</span></v-list-item-subtitle>-->
            </v-list-item-content>
            
            <v-list-item-action>
              <v-row class="ma-0 pa-0" justify="end">
                <action-button
                  v-if="hasControls(c.id)"
                  @click="downList(i)"
                  icon="$downList"
                  :tooltip="$t('webboxes.moveDown')"
                  :disabled="i == items.length - 1"
                />
                <action-button
                  v-if="hasControls(c.id)"
                  @click="upList(i)"
                  icon="$upList"
                  :tooltip="$t('webboxes.moveUp')"
                  :disabled="i == 0"
                />
              </v-row>
            </v-list-item-action>
          </v-list-item>
      </transition-group>
      <v-subheader>{{$t('campaigns.automatic.priority.low')}}</v-subheader>
    </v-list>
    <v-card-actions>
      <v-btn text color="primary" @click="confirm"><v-icon left>$ok</v-icon>{{$t('dialog.confirm')}}</v-btn>
      <v-btn text @click="$emit('cancel')"
        ><v-icon left>$nok</v-icon>{{$t('dialog.cancel')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
//import { mapState, mapGetters } from "vuex";
import Formatters from "@/mixins/formatters";

export default {
  name: 'CampaignPriorityControl',
  mixins: [Formatters],
  props: {
    movable: String,
    campaigns: Array
  },
  data() {
    return {
      items: this.copyList(),
    };
  },
  computed: {
  },
  watch: {
    campaigns() {
      this.items = this.copyList();
    },
  },
  methods: {
    hasControls(id) {
      if (!this.movable || id == this.movable) {
        return true;
      }
      return false;
    },
    mediumIcon(medium) {
      if (medium == 'email') {
        return '$mailing';
      }
      return '$mailing';
    },
    copyList() {
      console.debug('priorities campaigns', this.campaigns);
      if(!this.campaigns) {
        return [];
      }
      let cmp = this.campaigns.filter((c) => c.state != 'ARCHIVED');
      return cmp.map((c) => {
        // copy the campaign, add default priority field
        return { initialPriority: c.priority, ...c };
      });
    },
    confirm() {
      let changes = this.items.filter(c => c.initialPriority != c.priority).map(c=> { return { id: c.id, priority: c.priority }});
      console.debug('priority changes', changes);
      this.$emit('confirm', changes);
    },
    upList(i) {
        this.computePriority(i, +1);
        this.moveDownList(i-1);
    },
    downList(index) {
        this.computePriority(index, -1);
        this.moveDownList(index);
        
    },
    moveDownList(index) {
      let a = [...this.items]
      a[index+1] = this.items[index];
      a[index] = this.items[index+1];
      this.items = a;
    },
    computePriority(index, direction) {
      // paramter direction indicates priority change - positive value means higher priority
      // but the list is ordered inversely, top priority is the first item so index is decreasing
      let limit = direction > 0 ? 10000 : 0;
      direction = direction * -1;
      
      let currPriority = this.items[index].priority;
      let hPriority = this.items[index + (1 * direction)].priority;
      let lPriority = this.items[index + (2 * direction)]?.priority || limit;
      let newPriority = Math.ceil((hPriority + lPriority) /2);
      console.debug(`New priority for ${this.items[index].name}: ${newPriority} - old was ${currPriority}`);
      this.items[index].priority = newPriority;
    }
  }
};
</script>
<style scoped>
.list-move {
  transition: transform 0.5s ease-out;
}

.list-enter, .list-leave-to {
  opacity: 0;
}
.list-enter-active, .list-leave-active {
  transition: opacity 0.5s ease;
}

</style>